export const linkToStep = (stepTo) => {
  const locationArr = window.location.pathname.split('/');
  const cutIndex = locationArr.indexOf('ar');
  if (cutIndex > -1) {
    locationArr.splice(cutIndex, 1);
  }
  locationArr.splice(-1, 1, stepTo);
  const stepBackToUrl = locationArr.join('/');
  return stepBackToUrl;
};
